import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { BacklogConfigurationsApiResp } from '@/pages/OperationsInsights/types/BacklogConfigurationResponse';

export const fetchBacklogConfigurations = async (): Promise<BacklogConfigurationsApiResp> => {
    // This is to covert the beginning of the day in user time.
    const fetchUrl = '/workactivity/back-office/backlog/configurations';
    const resp = await fetchFromLambda(fetchUrl);
    return resp as BacklogConfigurationsApiResp;
};
